var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from "react";
import ShoppingListView from "../presentation/shopping-list";
import axios from 'axios';
import { connect } from "react-redux";
import CONSTS from "../consts";
export class ShoppingList extends React.Component {
    constructor(props) {
        super(props);
        this.updateToggle = (toggle) => {
            this.setState({ toggleMobile: toggle });
        };
        this.state = {
            products: [],
            toggleMobile: false
        };
    }
    getShoppingList(slist) {
        return __awaiter(this, void 0, void 0, function* () {
            if (slist.length) {
                let oDataPath = CONSTS.APIURL;
                let filterStr = slist.reduce((total, currentValue, index) => {
                    return index === 0 ? `${total}` : `${total}+or+DisplaySKU+eq+${currentValue}`;
                }, `DisplaySKU+eq+${slist[0] || ""}`);
                let query = `${oDataPath}Products?$filter=(${filterStr})`;
                const ShoppingPromise = yield axios.get(query);
                this.setState({
                    products: ShoppingPromise.data.value
                });
            }
        });
    }
    componentDidMount() {
        if (this.props.shoppingList) {
            this.getShoppingList(this.props.shoppingList);
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.shoppingList !== this.props.shoppingList) {
            this.getShoppingList(nextProps.shoppingList);
        }
    }
    render() {
        return (React.createElement(ShoppingListView, { products: this.state.products, toggleMobile: this.state.toggleMobile, updateToggle: this.updateToggle }));
    }
}
;
export function mapStateToProps({ shoppingList, authenticated, signInModal }) {
    return {
        shoppingList
    };
}
export default connect(mapStateToProps)(ShoppingList);
//# sourceMappingURL=shopping-list.js.map